import React, {FC} from 'react';

export type ColorTileProps = {
    color: string;
    width?: number;
    height?: number;
    tileClassName?: string;
    onClick?: () => void;
};

export const ColorTile: FC<ColorTileProps> = ({
    tileClassName,
    color,
    width = 32,
    height = 32,
    onClick
}) => {
    return (
        <div
            className={tileClassName}
            onClick={onClick}
            style={{width, height, borderRadius: 4, backgroundColor: color}}
        />
    );
};
